import { instance } from 'api/core';
import { AxiosResponse } from 'axios';
import { PickingVm } from './picking.vm';
import { plainToClass } from 'class-transformer';

export const getPicking = async (id: string): Promise<PickingVm> => {
    const config: Record<string, any> = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const res: AxiosResponse = await instance.get(`/picking/pickings/${id}`, config);
    return plainToClass(PickingVm, res.data);
};
